import Index from "@/views/root/Index";
import Callback from '@/views/root/Callback'
import NotFound from '@/views/root/NotFound'

export default [
    {
        name: 'index',
        path: '/',
        component: Index,
        meta: {
            permissionName: null
        }
    },
    {
        name: 'callback',
        path: '/callback',
        component: Callback,
        meta: {
            requiresAuthentication: false
        }
    },
    {
        name: `notfound`,
        path: '/404',
        component: NotFound
    }
]